import * as types from '../../Types';

const initialState = {
  employees: [],
  loading: false,
  error: null
};

const AdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_EMPLOYEES:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.FETCH_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employees: action.result,
        loading: false,
        error: null
      };
    case types.FETCH_EMPLOYEES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default AdminReducer;
